import ContentApiService from '@package/core/src/content/ContentApiService';
import ContentInteractor from '@package/core/src/content/ContentInteractor';
import StringHTMLBuilder from '@package/services/src/StringHTMLBuilder';

import { apiClient } from '../services';
import { useStrictQuery } from '../useCustomQuery';

import { FREE_SHIPPING_DATA_QUERY_KEY } from './types';

const contentService = new ContentApiService(apiClient);
const contentInteractor = new ContentInteractor(contentService, StringHTMLBuilder);

export default function useFreeShipping() {
  const { data: freeShippingHtml } = useStrictQuery([FREE_SHIPPING_DATA_QUERY_KEY], async () => {
    return contentInteractor.getFreeShippingModalContent();
  });

  return { freeShippingHtml };
}
